import { Option } from '@customTypes';

interface ConvertObjectProps {
  [key: string]: string;
}

export const convertObjectToOptions = (obj: ConvertObjectProps, valueAsNumber?: boolean): Option[] => {
  return (
    Object.entries(obj)
      .map(([key, value]) => ({
        value: valueAsNumber ? Number(key) : key,
        label: value,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) ?? []
  );
};
